<template>
  <div>
    <div class="mb-4">
      <vs-input
        class="w-full"
        :label="$t('title')"
        :placeholder="$t('title')"
        v-model="announcementFormData.title"/>
      <validation-error :model-error="announcementFormErrors.title"></validation-error>
    </div>

    <div class="mb-4">
      <label class="vs-input--label" v-text="$t('content')"></label>
      <quill-editor v-model="announcementFormData.content" :options="{ placeholder: $t('content') }"></quill-editor>
      <validation-error :model-error="announcementFormErrors.content"></validation-error>
    </div>

    <vs-checkbox v-model="announcementFormData.is_published"><span v-text="$t('publish')"></span></vs-checkbox>
  </div>
</template>

<script>
import Announcements from '@/models/Announcements'
import { EventBus } from '@/../eventbus'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import VueQuillEditor from 'vue-quill-editor'
import announcementSocket from '@/libs/sockets/announcements'

export default {
  name: 'Shared.Announcement.Add',
  components: {
    quillEditor: VueQuillEditor.quillEditor
  },
  computed: {
    server () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    }
  },
  data () {
    return {
      announcementFormData: {
        title: '',
        content: '',
        is_published: ''
      },
      announcementFormErrors: {}
    }
  },
  mounted () {
    EventBus.$on('initAnnouncementResetFormData', this.resetFormData)
    EventBus.$on('initSaveAnnouncement', this.saveFormData)
    announcementSocket.setNode(this.server)
  },
  methods: {
    async saveFormData () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addAnnouncementButton', scale: 0.45})

      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await Announcements.add(this.announcementFormData)
          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          announcementSocket.getSocket().emit('new_announcement_added')

          this.$emit('success')
          this.resetFormData()

        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.announcementFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }

      this.$vs.loading.close('#addAnnouncementButton > .con-vs-loading')
    },
    resetFormData () {
      this.announcementFormData = {
        title: '',
        content: '',
        is_published: ''
      }
      this.announcementFormErrors = {}
    }
  }
}
</script>

<style lang="scss">
  #addAnnouncementButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
